/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    declare var ResizeObserver: any;
    export class MeevoClientVisitNoteAnnotation implements angular.IDirective {
        restrict: 'E';
        templateUrl = 'app/components/controls/clientVisitNoteAnnotation/clientVisitNoteAnnotationTemplate.html';
        scope = {
            currentValue: '=ngModel',
            backgroundData: '@?',
            width: '@?',
            height: '@?',
            disabled: '=ngDisabled',
            required: '=?ngRequired',
            isAnnotated: '=?',
            canEdit: '=?',
            canDelete: '=?',
            clearCallback: '&?',
            editCallback: '&?',
            deleteCallback: '&?'
        };

        link = (scope, element, $window) => {
            scope.isEmpty = true;
            scope.visitNoteCanvas = null;

            scope.clearAnnotation = () => {
                scope.currentValue = '';
                scope.isEmpty = true;
                scope.isAnnotated = false;
                scope.visitNoteCanvas.clear();

                if (_.isFunction(scope.clearCallback)) {
                    scope.clearCallback();
                }
            };

            scope.editAnnotation = () => {
                if (_.isFunction(scope.editCallback)) {
                    scope.editCallback();
                }
            };

            scope.deleteAnnotation = () => {
                if (_.isFunction(scope.deleteCallback)) {
                    scope.deleteCallback();
                }
            };

            scope.getAnnotationData = () => {
                if (!scope.visitNoteCanvas.isEmpty()) {
                    scope.currentValue = scope.visitNoteCanvas.toDataURL();
                    scope.isAnnotated = true;
                }
            };

            scope.observeContainerSize = function () {
                let div = $('#visitNoteAnnotationContainer')[0] as HTMLDivElement;
                let canvas = $('#visitNoteAnnotationCanvas')[0] as HTMLCanvasElement;
                if (!div || !canvas) return;

                div.classList.add('loaded');
                let originalWidth = scope.imageWidth;
                let originalHeight = scope.imageHeight;
                let originalAspectRatio = originalWidth / originalHeight;
            
                let resizeTimeout;
                let resizeObserver = new ResizeObserver(function(entries) {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(() => {
                        originalWidth = scope.imageWidth;
                        originalHeight = scope.imageHeight;
                    }, 1000);

                    for (let entry of entries) {
                        if (entry.target === div) {
                            let newWidth = entry.contentRect.width;
                            let newHeight = entry.contentRect.height;
                
                            let widthChange = Math.abs(newWidth - originalWidth);
                            let heightChange = Math.abs(newHeight - originalHeight);
                
                            // maintain the aspect ratio
                            let resizeCanvas = (width: number, height: number) => {
                                requestAnimationFrame(() => {
                                    canvas.style.width = width + 'px';
                                    canvas.style.height = height + 'px';
                                    scope.imageWidth = width;
                                    scope.imageHeight = height;
                                    scope.onResize();
                                });
                            }         
                            if (widthChange > heightChange) {
                                // If the width changed more, adjust the height
                                resizeCanvas(newWidth, newWidth / originalAspectRatio);
                            } else {
                                // If the height changed more, adjust the width
                                resizeCanvas(newHeight * originalAspectRatio, newHeight);
                            }

                            break;
                        }
                    }
                });
                resizeObserver.observe(div);
            }

            scope.loadImageData = () => {
                if (scope.backgroundData) {
                    if (scope.width || scope.height) {
                        scope.imageWidth = scope.width;
                        scope.imageHeight = scope.height;
                        this.$timeout(() => scope.onResize(), 0);
                    }
                    else {
                        var vm = this;
                        const img = new Image();
                        img.onload = function () {
                            let containerWidth = $('md-dialog').width();
                            let containerHeight = $('md-dialog').height() * 0.66;
            
                            let aspectRatio = img.width / img.height;
            
                            if (img.width > containerWidth || img.height > containerHeight) {
                                if (aspectRatio > 1) {
                                    scope.imageWidth = containerWidth;
                                    scope.imageHeight = containerWidth / aspectRatio;
                                } else {
                                    scope.imageWidth = containerHeight * aspectRatio;
                                    scope.imageHeight = containerHeight;
                                }
                            } else {
                                scope.imageWidth = img.width;
                                scope.imageHeight = img.height;
                            }
            
                            if (scope.imageHeight > containerHeight) {
                                scope.imageWidth = containerHeight * aspectRatio;
                                scope.imageHeight = containerHeight;
                            }

                            scope.imageWidth = Math.floor(scope.imageWidth);
                            scope.imageHeight = Math.floor(scope.imageHeight);
            
                            vm.$timeout(() => {
                                scope.onResize();
                                scope.observeContainerSize();
                            }, 0);
                            
                            
                        }
                        img.src = scope.backgroundData;
                    }
                    scope.isAnnotated = true;
                }
            };

            scope.loadImageData();

            scope.fnDereg = scope.$watch('backgroundData', (newValue: any, oldValue: any) => {
                if (angular.isUndefined(newValue) || newValue === oldValue) {
                    return;
                }

                scope.loadImageData();
            }, true);

            scope.onResize = function () {
                let ratio = Math.max(window.devicePixelRatio || 1, 1);

                let canvas = element.find('canvas')[0];
                canvas.width = (scope.imageWidth || canvas.offsetWidth || scope.width) * ratio;
                canvas.height = (scope.imageHeight || canvas.offsetHeight || scope.height) * ratio;
                // Scaling is required to ensure annotation is lined up with image correctly; SignaturePad uses ratio (devicePixelRatio)
                canvas.getContext('2d').scale(ratio, ratio);

                scope.visitNoteCanvas = null;
                scope.visitNoteCanvas = new window['SignaturePad'](canvas, { onEnd: scope.getAnnotationData });
                if (scope.currentValue) {
                    scope.visitNoteCanvas.clear();
                    scope.visitNoteCanvas.fromDataURL(scope.currentValue);
                }
            };

            scope.$on('$destroy', () => {
                scope.fnDereg();
            });
        };

        constructor(private $timeout: ng.ITimeoutService) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout: ng.ITimeoutService) => {
                return new MeevoClientVisitNoteAnnotation($timeout);
            };

            directive.$inject = ['$timeout'];
            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoClientVisitNoteAnnotation', MeevoClientVisitNoteAnnotation.factory());

}